export const PendingStatus = {
  AWAITING_APPROVAL: 'Awaiting Approval',
  DRAFT: 'Draft',
  ERROR: 'Error',
  PAUSED: 'Paused',
  REJECTED: 'Rejected',
  SHARED_DRAFT: 'Shared Draft',
  FAILED_VALIDATION: 'FAILED VALIDATION',
} as const

export type PendingStatus = (typeof PendingStatus)[keyof typeof PendingStatus]

export const DatasetStatus = {
  APPROVED: 'Approved',
  COMPLETE: 'Complete',
  WARNING: 'Warning',
  PENDING: 'Pending',
} as const

export type DatasetStatus = (typeof DatasetStatus)[keyof typeof DatasetStatus]
